import ApiService from 'api-client/ApiService'
import config from 'app-config'

class OpenCloud extends ApiService {
  public getClassName() {
    return 'opencloud'
  }

  protected async getEndpoint() {
    return Promise.resolve(config.apiHost)
  }

  getRegionsMetadata = async () => {
    const url = `/oc-meta/meta/regions`
    const data = await this.client.basicGet<any>({
      url,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getRegionsMetadata',
      },
    })
    return data
  }
}

export default OpenCloud
